import { createPixatwinSdkExtensionRegistry } from "./extensionRegistry";
import { createPixatwinSdkModuleRegistry } from "./moduleRegistry";
import type {
  CreatePixatwinSdkOptions,
  PixatwinAccountMenuItemContribution,
  PixatwinBottomMenuContribution,
  PixatwinSdk,
  PixatwinSdkLifecycleStatus,
  PixatwinTopBarActionContribution,
  PixatwinViewerContribution,
  PixatwinViewerOverlayContribution,
  PixatwinViewerSidePanelContribution,
} from "./types";

const DEFAULT_SDK_VERSION = "0.1.0";

export const createPixatwinSdk = ({
  version = DEFAULT_SDK_VERSION,
}: CreatePixatwinSdkOptions = {}): PixatwinSdk => {
  let status: PixatwinSdkLifecycleStatus = "created";

  const modules = createPixatwinSdkModuleRegistry({
    canRegister: () => status === "created",
  });
  const viewerExtensions =
    createPixatwinSdkExtensionRegistry<PixatwinViewerContribution>({
      canRegister: () => status === "created",
      extensionType: "viewer",
    });
  const bottomMenuExtensions =
    createPixatwinSdkExtensionRegistry<PixatwinBottomMenuContribution>({
      canRegister: () => status === "created",
      extensionType: "bottomMenu",
    });
  const topBarExtensions =
    createPixatwinSdkExtensionRegistry<PixatwinTopBarActionContribution>({
      canRegister: () => status === "created",
      extensionType: "topBar",
    });
  const accountMenuExtensions =
    createPixatwinSdkExtensionRegistry<PixatwinAccountMenuItemContribution>({
      canRegister: () => status === "created",
      extensionType: "accountMenu",
    });
  const viewerOverlayExtensions =
    createPixatwinSdkExtensionRegistry<PixatwinViewerOverlayContribution>({
      canRegister: () => status === "created",
      extensionType: "viewerOverlay",
    });
  const viewerSidePanelExtensions =
    createPixatwinSdkExtensionRegistry<PixatwinViewerSidePanelContribution>({
      canRegister: () => status === "created",
      extensionType: "viewerSidePanel",
    });

  return {
    metadata: {
      name: "PIXAtwin SDK",
      version,
    },
    modules,
    extensions: {
      viewer: viewerExtensions,
      bottomMenu: bottomMenuExtensions,
      topBar: topBarExtensions,
      accountMenu: accountMenuExtensions,
      viewerOverlay: viewerOverlayExtensions,
      viewerSidePanel: viewerSidePanelExtensions,
    },
    getStatus() {
      return status;
    },
    start() {
      if (status === "started") {
        return;
      }

      status = "started";
    },
    stop() {
      if (status === "stopped") {
        return;
      }

      status = "stopped";
    },
  };
};
